import { render, staticRenderFns } from "./MessageSettingsIndivRecordRaw.vue?vue&type=template&id=f6de6ffa&scoped=true&"
import script from "./MessageSettingsIndivRecordRaw.vue?vue&type=script&lang=js&"
export * from "./MessageSettingsIndivRecordRaw.vue?vue&type=script&lang=js&"
import style0 from "./MessageSettingsIndivRecordRaw.vue?vue&type=style&index=0&id=f6de6ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6de6ffa",
  null
  
)

export default component.exports